<template>
  <mescroll-vue :up="getscrollData()" @init="initScroll" :down="mescrollDown">
    <div id="dataList">
      <div
        v-for="(item, index) in projectData"
        :key="index"
        @click="intoProject(item)"
      >
        <search-cell :msg="item | formatData"></search-cell>
      </div>
    </div>
  </mescroll-vue>
</template>
<script>
import SearchCell from "./searchCell.vue";
import MescrollVue from "mescroll.js/mescroll.vue";
import pub_methods from "./mixins/pub_methods.js";
export default {
  name: "project",
  mixins: [pub_methods],
  data() {
    return {
      projectData: [],
    };
  },
  components: {
    SearchCell,
    MescrollVue,
  },
  methods: {
    upCallback(page, mescroll) {
      this.getProjectData(page.num, page.size, mescroll);
    },
    getProjectData(pageNum, pageSize, mescroll) {
      let _this = this;
      let url = "index.php/mobile/search/trainplan-list";
      let params = {
        user_id: localStorage.getItem("_user_data_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        sys_id: 5,
        language: localStorage.getItem("_user_data_language"),
        size: 10,
        page: 1,
        keyword: _this.$store.state.searchWord,
        is_search: 1,
        trainplan_type: 2,
        // client_version:'1.2.0'
      };
      this.$axios.post(url, params).then(function (res) {
        if (res.data.code == 0) {
          let data = res.data.result.data;
          if (pageNum == 1) {
            _this.projectData = [];
          }
          _this.projectData = _this.projectData.concat(data);
          _this.$nextTick(() => {
            if (pageNum > res.data.result.pages.page_count) {
              mescroll.endSuccess(data.length, false);
            } else {
              mescroll.endSuccess(data.length, true);
            }
          });
        }
      });
    },
    intoProject(item) {
      if (item.template_style === "p2p") {
        this.$router.push({
          path: "/P2Pstudy/study_way",
          query: { tid: item.trainplan_id },
        });
      } else {
        this.$router.push({
          path: "/main/project_stage",
          query: { tid: item.trainplan_id },
        });
      }
    },
  },
  filters: {
    formatData(item) {
      return {
        name: item.trainplan_name,
        type: "project",
        trainplan_name: item.category_name,
        trainplan_type: item.trainplan_type,
      };
    },
  },
};
</script>

<style lang="less" scoped>
#dataList {
  /deep/.mescroll-empty {
    height: 90vh;
    background: #fff;
    .empty-icon {
      margin: 1rem auto 0;
    }
  }
}
</style>
